import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout, Container } from '../components/layout';
import { Button, Card, CardBody } from '../components/ui';

interface LocationState {
  error?: string;
}

export const ErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const errorMessage = state?.error || 'An unexpected error occurred';

  return (
    <Layout>
      <Container maxWidth="md">
        <div
          className="flex flex-col items-center justify-center"
          style={{ minHeight: '60vh', padding: 'var(--space-12) 0' }}
        >
          <Card style={{ width: '100%' }}>
            <CardBody>
              <div className="text-center">
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto var(--space-6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'var(--color-error)',
                    color: 'var(--color-bg)',
                  }}
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </div>

                <h2 style={{ marginBottom: 'var(--space-4)' }}>
                  Generation Failed
                </h2>

                <p
                  className="text-muted"
                  style={{
                    fontSize: 'var(--text-lg)',
                    marginBottom: 'var(--space-6)',
                  }}
                >
                  {errorMessage}
                </p>

                <div
                  style={{
                    padding: 'var(--space-4)',
                    backgroundColor: 'var(--danger-bg)',
                    border: 'var(--border-thick)',
                    borderColor: 'var(--color-error)',
                    marginBottom: 'var(--space-8)',
                    fontFamily: 'var(--font-mono)',
                    fontSize: 'var(--text-sm)',
                    textAlign: 'left',
                  }}
                >
                  <strong>Error Details:</strong>
                  <br />
                  {errorMessage}
                </div>

                <div className="flex gap-4 justify-center">
                  <Button
                    variant="ghost"
                    onClick={() => navigate(-1)}
                  >
                    Go Back
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => navigate('/')}
                  >
                    Start Over
                  </Button>
                </div>

                <div
                  style={{
                    marginTop: 'var(--space-8)',
                    padding: 'var(--space-4)',
                    backgroundColor: '#f9fafb',
                    border: 'var(--border-thin)',
                  }}
                >
                  <p
                    style={{
                      fontFamily: 'var(--font-body)',
                      fontSize: 'var(--text-sm)',
                      color: 'var(--color-muted)',
                      margin: 0,
                    }}
                  >
                    If this error persists, please try again later or check your
                    internet connection. The generation service may be temporarily
                    unavailable.
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Layout>
  );
};

export default ErrorPage;
